interface Config {
    isProd: boolean;
    baseUrl: string;
}

const isOnProd = process.env.NODE_ENV === 'production';
const apiUrl = isOnProd
    ? process.env.REACT_APP_BOKUN_URL.replace(
          '.bokun.io',
          window.location.host.replace('appstore', '')
      )
    : process.env.REACT_APP_BOKUN_URL;

export const config: Config = {
    isProd: isOnProd,
    baseUrl: apiUrl,
};
